import { Button, ClassNameProps, Column, Heading, If, Modal, ModalProps, Row, StyleProps } from "@hex-insights/core";
import { Icon } from "../../../../Components/Icon";
import { useRecordViewOnMount } from "../../../../Utilities";
import { DetailDisplayNewsletter, NewsletterDetailDisplay } from "../DetailDisplay";

export type ModalNewsletter = DetailDisplayNewsletter;

export type NewsletterModalProps = {
	newsletter: ModalNewsletter;
	noReactions?: boolean;
	noComments?: boolean;
	noOtherNewsletters?: boolean;
	isPreview?: boolean;
	withBackButton?: boolean;
	backButtonText?: string;
} & Pick<ModalProps, "ifRef" | "onClose"> &
	Partial<ClassNameProps & StyleProps>;

export function NewsletterModal({
	newsletter,
	noReactions = false,
	noComments = false,
	noOtherNewsletters = false,
	isPreview = false,
	backButtonText = "Back to Newsletters",
	withBackButton = false,
	ifRef,
	onClose,
	className,
	style,
}: NewsletterModalProps) {
	useRecordViewOnMount(newsletter.id);

	return (
		<Modal ifRef={ifRef} size="large" onClose={onClose} className={className} style={style}>
			<Modal.Header>
				<Column justify="spaced-start" verticalSpacing="0.25rem">
					<If condition={withBackButton}>
						{onClose && (
							<Button variant="link" size="small" onClick={onClose}>
								<Row justify="spaced-start" align="center" horizontalSpacing="0.375rem">
									<Icon.ArrowLeft size={14} /> {backButtonText}
								</Row>
							</Button>
						)}
					</If>

					<Heading.H2 noMargin>{newsletter.title}</Heading.H2>
				</Column>
			</Modal.Header>
			<Modal.Body>
				<NewsletterDetailDisplay
					newsletter={newsletter}
					withReactions={!noReactions}
					withComments={!noComments}
					withOtherNewsletters={!noOtherNewsletters}
					editable
					isPreview={isPreview}
				/>
			</Modal.Body>
		</Modal>
	);
}
